import {
  boolean,
  type InferOutput,
  number,
  object,
  optional,
  string
} from 'valibot'

import {
  createSorterSchema,
  DRIVER_USERS_SORT_KEYS
} from '@/features/shared/models'

export const UsersSearchSchema = object({
  page: optional(number()),
  take: optional(number()),
  ...createSorterSchema(DRIVER_USERS_SORT_KEYS),
  displayName: optional(string()), // ユーザー名
  partnerId: optional(number()), // パートナー
  subPartnerId: optional(number()), // 実運送会社
  dcId: optional(number()), // 拠点
  enable: optional(boolean()) // 有効状態
})

export type UsersSearch = InferOutput<typeof UsersSearchSchema>
